// @flow
import React, { PureComponent } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

type OwnProps = {};

export type StateProps = {
  showAlertInfo: string,
  message_alerte: {
    raw: string, 
    data: BlocContent[],
  }
};

export type DispatchProps = {
  closeAlertInfo: (raw: string) => void
};

type Props = OwnProps & StateProps & DispatchProps;

class Alert extends PureComponent<Props> {
  renderDetail = () => {
    const { message_alerte } = this.props;
    return message_alerte.data.map<any>((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  };
  render() {
    const { message_alerte } = this.props;
    if ((!this.props.showAlertInfo || this.props.showAlertInfo !== message_alerte.raw) && message_alerte.data.length > 0)
      return (
        <div className="warning">
          <div className="warning__wrapper">
            <i className="icon icon-close" onClick={() => this.props.closeAlertInfo(message_alerte.raw)}></i>  
            {this.renderDetail()}
          </div>
        </div>
      );

    return null;
  }
}

export default Alert;
